import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table/table";
import { getOneLoanRequestForEmployeeQueryOptions } from "@/config/queries/emp-query-options";
import { useMemo } from "react";
import { DataTable } from "./_components/repayment-schedule-table/data-table";
import { columns } from "./_components/repayment-schedule-table/columns";
import { Separator } from "@/components/ui/separator/separator";
import { RepaymentRequests } from "./_components/repayment-requests/repayment-requests";

const EmployeeIndividualLoanPage = () => {
  const employeeKey = Cookies.get("key") as string;
  const { loanId } = useParams() as {
    loanId: string;
  };

  const { data, isPending, isFetching } = useQuery(
    getOneLoanRequestForEmployeeQueryOptions(employeeKey, loanId)
  );

  const repaymentScheduleData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.loan === undefined) {
      return [];
    }

    const result = data?.loan?.repaymentSchedule?.map((item) => {
      return {
        id: item?._id,
        amount: item?.amount,
        createdAt: item?.createdAt,
        dueDate: item?.dueDate,
        paidAmount: item?.paidAmount,
        status: item?.status,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  return (
    <div className="p-3 min-h-[calc(100%-56px)] overflow-y-auto">
      <div className="">
        <h3 className="text-2xl font-medium underline underline-offset-4">
          Loan Request
        </h3>
      </div>
      <div className="py-5 mt-3">
        <div className="max-w-5xl mx-auto px-3 md:px-0">
          <Table className="border shadow">
            <TableCaption>Summary of Loan Request</TableCaption>
            <TableHeader>
              <TableRow>
                <TableHead className="w-auto">Total Requested Amount</TableHead>
                <TableHead>Total Approved Amount</TableHead>
                <TableHead>Interest Rate</TableHead>
                <TableHead className="text-right">
                  Total Repayment Amount
                </TableHead>
                <TableHead className="text-right">Remaining Balance</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell className="font-medium">
                  ₹{data?.loan?.totalAmountRequested}
                </TableCell>
                <TableCell className="text-center">
                  ₹{data?.loan?.totalAmountApproved}
                </TableCell>
                <TableCell className="text-center">
                  {data?.loan?.interestRate}
                </TableCell>
                <TableCell className="text-center">
                  ₹{(data?.loan?.totalRepaymentAmount as number)?.toFixed(3)}
                </TableCell>

                <TableCell className="text-center">
                  ₹{(data?.loan?.remainingBalance as number)?.toFixed(3)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <Separator className="my-4" />

        <div className="px-3 md:px-6">
          <h2 className="mb-4 text-lg font-medium">Repayment Schedules</h2>
          {/* Repayment Schedule Data Table */}
          <DataTable data={repaymentScheduleData!} columns={columns} />
        </div>

        <div className="px-3 md:px-6">
          <Separator className="mt-4" />

          <RepaymentRequests />
        </div>
      </div>
    </div>
  );
};

export default EmployeeIndividualLoanPage;
